import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class CostDocumentOtherItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @IsOptional()
  @Expose()
  index!: number | null;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  quantity!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  vat!: string;
  @IsNumber()
  @Expose()
  vatAmountInCurrency!: number;
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
}
